<template>
  <section class="site-conversion" ref="root">
    <div class="site-conversion__spacer-top">

    </div>  
    <div class="site-conversion__real">
      <div class="site-conversion__real__wrapper">
        <div class="site-conversion__real__wrapper__logo">
          <Animation
            v-if="mounted"
            class="site-conversion__real__wrapper__logo__inner"
          />
        </div>
        <div class="site-conversion__real__wrapper__detail">
          <h2 class="site-conversion__real__wrapper__detail__title site-section-title">
            Gratuit, illimité, sans engagement
          </h2>
          <div class="site-conversion__real__wrapper__detail__subtitle">
            Générez vos CRA gratuitement, sans limite. Signature électronique, validation client et export PDF inclus. Passez à l'offre Intégration pour le tableau de bord, les notifications et l'intégration avec vos outils de facturation.
          </div>
          <SiteButton
            class="site-conversion__real__wrapper__detail__action"
            label="Créer mon premier CRA"
            type="secondary"
            has-arrow
            @click="$router.push({ name: 'app' })"
          />
        </div>
        
      </div>
      
    </div>
    <div class="site-conversion__spacer-bottom">
    </div>
    <GlobalEvents
      target="window"
      @scroll="appear"
    />
  </section>
</template>

<script setup>
  import SiteButton from '@/components/SiteButton'
  import debounce from 'lodash.debounce'
  import { GlobalEvents } from 'vue-global-events'

  const Animation = defineAsyncComponent(() => import('./Animation'))
  const emit = defineEmits(['signup'])

  const root = ref(null)

  const mounted = ref(false)

  setTimeout(() => {
    mounted.value = true
  }, 3000)

  const appear = debounce(() => {
    if (!mounted.value && root.value.getBoundingClientRect().y - window.innerHeight < 0) {
      mounted.value = true
    }
  }, 200, {
    maxWait: 200
  })
</script>

<style lang="scss">

  $desktop-breakpoint: 990px;
  $tablet-breakpoint: 672px;
  
  .site-conversion {

    &__spacer-top {
      height: 187px;
      @media screen and (min-width: $desktop-breakpoint) {
        height: 55px;
      }
    }

    &__real {
      background-color: #99B7D010;
      display: flex;
      justify-content: center;

      &__wrapper {
        flex-grow: 10;
        max-width: 1260px;
        margin: 0 15px;
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: center;

        @media screen and (min-width: $desktop-breakpoint) {
          flex-direction: row;
          justify-content: space-between;
          margin: 20px 30px;
        }

        &__logo {
          &__inner {
            width: 218.6px;
            transform: translateX(-3px);
            margin-top: -70%;

            @media screen and (min-width: $desktop-breakpoint) {
              margin-top: initial;
              transform: scale(1.78);
              transform-origin: left;
              margin-right: 220px;
            }
          }
        }

        &__detail {
          flex-grow: 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          @media screen and (min-width: $desktop-breakpoint) {
            align-items: flex-start;
          }
          &__title {
            margin-top: 25px;
            font-size: 40px;
            font-weight: 500;
            color: #01498B;
            text-align: center;
            @media screen and (min-width: $desktop-breakpoint) {
              text-align: left;
            }
          }

          &__subtitle {
            margin-top: 20px;
            font-size: 18px;
            font-weight: 26px;
            font-weight: 400;
            text-align: center;
            font-weight: 300;
            font-size: 18px;
            line-height: 26px;
            color: #01498B;
            @media screen and (min-width: $desktop-breakpoint) {
              text-align: left;
            }
          }

          &__action {
            margin-top: 30px;
            margin-bottom: 30px;
          }
        }
      }
    }

    &__spacer-bottom {
      height: 0;
      @media screen and (min-width: $desktop-breakpoint) {
        height: 55px;
      }
    }
  }
</style>
